import { type AppState } from '../rootReducer';

export const getCurrentModal = (state: AppState) => state.modals.currentModal;
